/* eslint-disable */
import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useJobs } from 'src/hooks/query/jobs';
import { useMailMergeTemplate } from 'src/hooks/query/mailMerge';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';
import RHFAutoComplete from '../elements/AutoComplete/RHFAutoComplete';
import RHFEditor from '../elements/Editor/RHFEditor';
import RHFEmailsChips from '../elements/EmailsChips/RHFEmailsChips';
import RHFInput from '../elements/Input/RHFInput';

export interface SendMailFormValues {
  to: Array<string>;
  cc?: Array<string> | null;
  subject: string;
  content: string;
  jobOrderId: number | undefined | null;
}

const validationSchema = yup.object().shape({
  to: yup.array(yup.string().email()).required('Must have at least 1 email'),
  cc: yup.array(yup.string().email()).optional(),
  subject: yup.string().required('subject required').min(1, 'Subject required'),
  content: yup.string().required('email content required'),
  jobOrderId: yup.number().required('Select job'),
});

interface SendMailProps {
  onSubmit: (data: SendMailFormValues) => void;
  loading: boolean;
  defaultValues?: SendMailFormValues | undefined;
}

const SendMail = function SendMail(props: SendMailProps) {
  const { onSubmit, defaultValues } = props;
  const resolver = useYupValidationResolver(validationSchema);
  const { jobsLoading, jobsOptions } = useJobs();

  const { templateFetching, getTemplate } = useMailMergeTemplate();
  const methods = useForm<SendMailFormValues>({
    defaultValues,
    resolver,
  });

  const {
    handleSubmit,
  } = methods;

  useEffect(() => {
    methods.reset(defaultValues);
  }, [defaultValues]);

  const submitHandler: SubmitHandler<SendMailFormValues> = async (data) => {
    console.log('data', data);
    onSubmit(data);
  };

  const handleJobChange = async (jobOrderId: number) => {
    if (jobOrderId) {
      methods.setValue('subject', "");
      methods.setValue('content', "");
      const template = await getTemplate(jobOrderId);

      methods.setValue('subject', template.mailSubject);
      methods.setValue('content', template.mailContent);
    } else {
      methods.setValue('subject', "");
      methods.setValue('content', "");
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitHandler)} className="bg-white  p-10 flex gap-8 justify-center items-center flex-col">
        <div className="flex w-full p-4 flex-col gap-10">
         <div className="w-full flex-shrink-0">
            <RHFAutoComplete
              control={methods.control}
              name="jobOrderId"
              label="Job"
              placeholder="Select job"
              options={jobsOptions}
              onSelectChange={handleJobChange}
              loading={jobsLoading}
            />
          </div>
          <div className="w-full flex-shrink-0">
            <RHFEmailsChips
              control={methods.control}
              name="to"
              label="To"
              placeholder="Enter emails"
            />
          </div>
          <div className="w-full flex-shrink-0">
            <RHFEmailsChips
              control={methods.control}
              name="cc"
              label="cc"
              placeholder="Enter emails"
            />
          </div>
          <div className="w-full flex-shrink-0">
            <RHFInput
              control={methods.control}
              name="subject"
              label="Subject"
              placeholder="Subject"
              disabled={templateFetching}
            />
          </div>
          <div className="w-full h-[200px] flex-shrink-0">
            <RHFEditor
              control={methods.control}
              name="content"
              disabled={templateFetching}
            />
          </div>
        </div>
        <div className="w-full flex  gap-2 ">
          <Button variant="contained" type="submit" size="small" className="font-medium rounded-full">Send</Button>
        </div>
      </form>
    </FormProvider>
  );
};

SendMail.defaultProps = {

};

SendMail.propTypes = {

};

export default SendMail;
